module.exports = __webpack_public_path__ + "static/media/22ESCWA13.ff20c1e4.jpg";